import React, { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { DataCacheProvider } from '../../providers';
import {
  AlertProvider,
  DomainProvider,
  LiveRegionProvider,
  ModeProvider,
  SearchProvider,
  ToggleLocationProvider,
} from '../../contexts';
import CustomAlert from '../CustomAlert';

interface AppContainerProps {
  children: ReactNode;
}

const AppContainer: React.FC<AppContainerProps> = ({ children }) => {
  return (
    <BrowserRouter>
      <AlertProvider>
        <LiveRegionProvider>
          <DataCacheProvider>
            <DomainProvider>
              <SearchProvider>
                <ModeProvider>
                  <ToggleLocationProvider>
                    <CustomAlert />
                    {children}
                  </ToggleLocationProvider>
                </ModeProvider>
              </SearchProvider>
            </DomainProvider>
          </DataCacheProvider>
        </LiveRegionProvider>
      </AlertProvider>
    </BrowserRouter>
  );
};

export default AppContainer;
